import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackButtonClick } from './tracking';
import { getNewbuildingHousesOffers } from '../../actions/newbuildingHouses';
import { Dispatch } from '../../common/state';
import { MultiSelectDesktop } from '../../components/MultiSelectDesktop';
import { NewbuildingHousesFilter } from '../../components/NewbuildingHousesFilter';
import { getHouses, getNewbuildingId, getActiveHouses } from '../../selectors/newbuildingHeader';

export const NewbuildingHousesFilterContainer = ({ withLabel }: { withLabel?: boolean }) => {
  const houseIdSelected = useSelector(getActiveHouses);
  const housesFilterOptions = useSelector(getHouses);
  const newbuildingId = useSelector(getNewbuildingId);
  const [value, setValue] = React.useState(houseIdSelected);
  const dispatch: Dispatch = useDispatch();

  const onChange = React.useCallback(
    (value: number[]) => {
      setValue(value);
      dispatch({
        type: 'filters/newbuildig_houses/SET_NEWBUILDING_HOUSE_IDS',
        houseIds: value,
        newbuildingId,
      });

      dispatch(getNewbuildingHousesOffers());

      trackButtonClick(newbuildingId as number);
    },
    [dispatch, newbuildingId],
  );

  if (!housesFilterOptions) {
    return null;
  }

  return (
    <NewbuildingHousesFilter withLabel={withLabel}>
      <MultiSelectDesktop
        defer={true}
        placeholderActive={true}
        placeholder="Все корпуса"
        value={value}
        options={housesFilterOptions.map(house => ({
          value: house.id,
          label: house.name,
          description: house.finishStatus,
        }))}
        onChange={onChange}
      />
    </NewbuildingHousesFilter>
  );
};
